import React from "react";
import SheetGround from "../../shared/ui/SheetGround";
import { useRegister } from "../../sections/desk/useRegister";
import { P, PAGE_MAX, PAGE_PAD, MARGIN_W, COL_GAP, Spine, folioCss } from "./shell";
import { VELLUM as T, SANS } from "./tokens";
import { LeafSheet, LeafPosts } from "./LeafRegister";
import { LeafAnatomy } from "./LeafAnatomy";
import { LeafInstitutions } from "./LeafInstitutions";
import { LeafIndex } from "./LeafIndex";
import { LeafUndertakings } from "./LeafUndertakings";
import { Close } from "./Close";

/* The landing page, drawn as a folio.

   One request serves the whole page - the opening entries, the annotated
   entry, the field schedule and every figure quoted in the margin - so the
   register reads truthfully at three entries and at three thousand.

   The page draws the sheet ground and the leaves; the header and footer are
   the app's own and are shared with every other route. */

export const FolioLanding: React.FC = () => {
  const register = useRegister();

  return (
    <SheetGround theme={T} className={`${P}-root`} style={{ fontFamily: SANS, color: T.ink }}>
      <div
        className={`${P}-grid`}
        style={{
          maxWidth: PAGE_MAX,
          margin: "0 auto",
          padding: `0 ${PAGE_PAD}px`,
          display: "grid",
          gridTemplateColumns: `minmax(0, 1fr) 1px ${MARGIN_W}px`,
          columnGap: COL_GAP,
          alignItems: "start",
        }}
      >
        <Spine />

        <LeafSheet register={register} />
        <LeafPosts register={register} />
        <LeafAnatomy register={register} />
        <LeafInstitutions />
        <LeafIndex register={register} />
        <LeafUndertakings />
      </div>

      <Close />

      <style>{folioCss}</style>
    </SheetGround>
  );
};
